"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERACTION_STATE = void 0;
var INTERACTION_STATE;
(function (INTERACTION_STATE) {
    INTERACTION_STATE["DOWN"] = "down";
    INTERACTION_STATE["MOVE"] = "move";
    INTERACTION_STATE["END"] = "end";
})(INTERACTION_STATE = exports.INTERACTION_STATE || (exports.INTERACTION_STATE = {}));
//# sourceMappingURL=IInteractionEngine.js.map